<template>
  <div class="animated fadeIn">
    <div
      class="card login m-3 m-lg-5"
      :style="[!loggedIn ? {'height': '85vh'} : {'height': 'auto', 'flex': '1'}]"
    >
      <div class="card-header">
        <h2 class="text-center mt-3">ورود به حساب کاربری</h2>
      </div>
      <div class="card-body">
        <div
          class="row"
          :style="[!loggedIn ? {'transform': 'translateY(80%)'} : {'transform': 'translateY(0)'}]"
        >
          <!--<div class="col-lg-4 mr-auto ml-auto">-->
          <!--<div class="input-group">-->
          <!--<div class="input-group-prepend">-->
          <!--<span class="input-group-text">-->
          <!--<i class="icon-baseline-perm_identity-24px"></i>-->
          <!--</span>-->
          <!--</div>-->
          <!--<input-->
          <!--class="form-control"-->
          <!--type="text"-->
          <!--placeholder="نام کاربری"-->
          <!--v-model="login.username"-->
          <!--@keydown.enter="onLoginClicked"-->
          <!--&gt;-->
          <!--</div>-->
          <!--<div class="input-group mt-3">-->
          <!--<div class="input-group-prepend">-->
          <!--<span class="input-group-text">-->
          <!--<i class="icon-baseline-https-24px"></i>-->
          <!--</span>-->
          <!--</div>-->
          <!--<input-->
          <!--class="form-control"-->
          <!--type="password"-->
          <!--placeholder="رمز عبور"-->
          <!--v-model="login.password"-->
          <!--@keydown.enter="onLoginClicked"-->
          <!--&gt;-->
          <!--</div>-->
          <!--<div class="text-center mt-3">-->
          <!--<button class="btn btn-success w-100" @click="onLoginClicked">ورود</button>-->
          <!--</div>-->
          <!--</div>-->
        </div>
        <div
          v-if="loggedIn"
          class="row mt-5 animated fadeIn company-post"
          style="animation-duration: 2s"
        >
          <div class="col-lg-12">
            <h4 class="text-center">لطفا شرکت و نقش خود را انتخاب کنید</h4>
          </div>
          <div class="col-lg-4" v-for="(item, index) in roles">
            <div class="form-check" @click="onRoleClicked(index)">
              <input class="form-check-input" type="radio" name="radio" :id="index">
              <label
                class="form-check-label d-flex mb-2"
                :for="index"
              >{{item.companyName}} / {{item.post.name}}</label>
            </div>
          </div>
          <div class="col-lg-12 text-center mt-5">
            <button class="btn btn-secondary" @click="onSubmitClicked">ثبت</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseService from "../_framework/api/BaseService.js";
  import axios from "axios";
  import Utils from "../_framework/utils/Utils";

  export default {
    name: "ChangeRole",
    data() {
      return {
        login: {
          username: "",
          password: "",
          userPostId: 0
          /*postId: 0,
          companyId: 0*/
        },
        loggedIn: false,
        roles: []
      };
    },
    methods: {
      // onLoginClicked() {
      //   new BaseService("auth", "/authenticate")
      //     .create(this.login)
      //     .then(response => {
      //       // console.log(response);
      //       this.loggedIn = true;
      //       this.roles = response.data;
      //       if (response.data.length === 1) {
      //         this.onRoleClicked(0);
      //         this.onSubmitClicked();
      //       }
      //     });
      //   // .catch(error => {
      //   //   Utils.handleErrorWithNotification(
      //   //     error.response.data.message,
      //   //     this.$noty
      //   //   );
      //   // });
      // },
      onRoleClicked(index) {
        this.login.userPostId = this.roles[index].id;
        // this.login.postId = this.roles[index].post.id;
        localStorage.setItem("company", this.roles[index].companyName);
        /* localStorage.setItem("companyId", this.login.companyId);
         localStorage.setItem("company", this.roles[index].companyName);
         localStorage.setItem(
           "post",
           this.roles[index].post.postName || this.roles[index].post.name
         );*/
        // localStorage.setItem("postId", this.roles[index].post.id);
        localStorage.setItem(
          "post",
          this.roles[index].post.postName || this.roles[index].post.name
        );
        localStorage.setItem("username", this.login.username);
        this.onSubmitClicked();
      },
      onSubmitClicked() {
        new BaseService("auth", "/login").create(this.login).then(response => {
          // console.log(response.data)
          localStorage.setItem("companyId", response.data.companyId);
          localStorage.setItem("outSourceId", response.data.outSourceId);
          localStorage.setItem("postId", response.data.postId);
          // localStorage.setItem("company", this.roles[index].companyName);
          let authToken = response.data.auth_token;
          localStorage.setItem("auth_token", authToken);
          axios.defaults.headers.common["Authorization"] = "Bearer " + authToken;
          new BaseService("auth", "/GetUserAccessPage").getList().then(rs => {
            localStorage.setItem("accesses", JSON.stringify(rs.data));
            if (response.data.companyId == null || response.data.companyId == '') {
              this.$router.push({path: "/customerOrders"});
            } else  if (response.data.companyId == '1') {
              this.$router.push({path: "/dashboard"});
            }else{
              this.$router.push({path: "/works-home"});
            }
            /*if (response.data.companyId === "1") {
                this.$router.push({path: "/"});
            } else {
                this.$router.push({path: "customerOrders"})
            }*/
          });
        });
      }
    },
    beforeMount() {
      this.loggedIn = true;
      this.roles = JSON.parse(localStorage.getItem("my_companies"));
      this.login = JSON.parse(localStorage.getItem("my_login"));
      // console.log(this.roles);
      // console.log(this.login);

    }
  };
</script>

<style lang="scss" scoped>
  .input-group-text i {
    margin-left: 0;
    padding: 0.3rem;
  }

  .form-control {
    padding: 1.25rem 0.75rem;
  }

  .card.login button {
    font-size: 1.5rem;
    padding: 0.5rem 1.5rem;
  }

  .form-check-label:hover {
    cursor: pointer;
  }

  .form-check-input {
    padding: 1rem 1.5rem;
    top: 40%;
    margin-left: 0;
    margin-right: 0.25rem;
    margin-top: 0;
  }

  .card.login {
    transition: all 3s;
    box-shadow: 0 5px 15px 5px rgba(0, 0, 0, 0.25);
  }

  .card-body > .row {
    transition: transform 1s;
    transition-timing-function: ease-in-out;
  }
</style>
